// extracted by css-extract-rspack-plugin
export default {"container":"_60060571","title":"_a6acdff6"};